var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 90,
    viewBox: "0 0 107 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6249 8.3238C13.3191 7.22543 11.202 7.22539 9.89616 8.32373C8.59031 9.42207 8.59027 11.2029 9.89607 12.3012L15.4696 16.9893C11.5231 19.1667 8.91675 22.9211 8.91675 27.1875V62.8125L8.93967 63.504C9.36593 69.9135 15.6799 75 23.4063 75H83.5938L84.4137 74.9809L92.3741 81.6769C93.6799 82.7753 95.7972 82.7753 97.103 81.6769C98.4089 80.5785 98.4089 78.7976 97.103 77.6993L14.6249 8.3238ZM77.749 69.375H23.4063L22.7664 69.3533C18.7568 69.0795 15.6043 66.2558 15.6043 62.8125V35.1525L51.9428 51.2389L52.3712 51.3975C53.2464 51.6615 54.2219 51.6086 55.0574 51.2389L55.7979 50.9111L77.749 69.375ZM44.9512 41.7874L15.6043 28.7963V27.1875L15.6301 26.6493C15.8707 24.1563 17.7679 22.0572 20.3945 21.1319L44.9512 41.7874Z",
    fill: "#0091EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3958 28.7925L63.2388 41.2597L68.1898 45.4241L91.3958 35.1487V62.8125L91.37 63.3506C91.3258 63.807 91.2264 64.2502 91.0771 64.6755L96.131 68.9265C97.3722 67.1295 98.0833 65.0407 98.0833 62.8125V27.1875L98.0606 26.4959C97.6339 20.0867 91.32 15 83.5938 15H32.0195L38.7069 20.625H83.5938L84.2335 20.6467C88.2433 20.9205 91.3958 23.7444 91.3958 27.1875V28.7925Z",
    fill: "#0091EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.840342acf344be9f89abab6d15052197.svg";
export { ForwardRef as ReactComponent };